/**
 * Given a string of data, return a SHA-256 hash of that data.
 */
export const hash = async (data) => {
    const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(data));
    return Array.prototype.map
        .call(new Uint8Array(hashBuffer), x => ('00' + x.toString(16)).slice(-2))
        .join('');
};
